<template>
    <div class="text-center">
        <b-button-group>
            <b-button v-if="parseInt(value) > 1" variant="none" @click="$emit('input', 1)"
                >
                &emsp;<font-awesome-icon class="fa-fw" icon="chevron-double-left" />&emsp;
            </b-button>
            <b-button
                v-if="parseInt(value) > 1"
                variant="none"
                @click="$emit('input', parseInt(value) - 1)"
                >
                &emsp;<font-awesome-icon class="fa-fw" icon="chevron-left" />&emsp;
            </b-button>
            <b-button variant="none" disabled>
                {{ value }}
                <template v-if="nbPages !== ''">
                    /
                    {{ nbPages }}
                </template>
            </b-button>
            <b-button
                v-if="parseInt(value) < parseInt(nbPages) || nbPages === ''"
                variant="none"
                @click="$emit('input', parseInt(value) + 1)"
                >
                &emsp;<font-awesome-icon class="fa-fw" icon="chevron-right" />&emsp;
            </b-button>
            <b-button
                v-if="parseInt(value) < parseInt(nbPages)"
                variant="none"
                @click="$emit('input', nbPages)"
                >
                &emsp;<font-awesome-icon class="fa-fw" icon="chevron-double-right" />&emsp;
            </b-button>
        </b-button-group>
        <p v-if="nbHits !== ''">{{ nbHits | baseNumberFormatter }} 件のデータが見つかりました</p>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: [ Number, String, ],
            required: true,
            default() {
                return ''
            },
        },
        nbPages: {
            type: [ Number, String, ],
            required: false,
            default: '',
        },
        nbHits: {
            type: [ Number, String, ],
            required: false,
            default: '',
        },
    },
    data() {
        return {}
    },
    computed: {},
    async mounted() {},
    methods: {},
}
</script>

<style lang="scss" scoped>
.filter-item-option {
    display: block;

    &[active] {
    }

    &:not([active]) {
        opacity: 0.3;
    }

    [type='radio'] {
        display: none;
    }

    .filter-item-option-text {
        cursor: pointer;
    }
}
</style>


